<template>
  <div>
    <b-media
      class="mb-md-3 bg-form-header d-flex flex-sm-row flex-column-reverse justify-content-between align-items-center p-md-2 p-1 rounded"
      no-body
    >
      <div class="d-flex justify-content-start align-items-center mt-sm-0 mt-2">
        <b-media-aside class="mr-1">
          <b-avatar size="45" class="rounded-avatar bg-secondary" />
        </b-media-aside>
        <b-media-body class="d-flex align-items-center text-white">
          <h4 class="font-weight-bolder text-white mb-0">
            Rules and conditions
          </h4>
          <feather-icon
            icon="HelpCircleIcon"
            size="16"
            class="font-weight-bolder ml-75 rounded-circle cursor-pointer"
            v-b-tooltip.hover="'Rules and conditions'"
          />
        </b-media-body>
      </div>
      <b-link :to="{ name: 'competitions' }">
        <span>back to the competitio list </span>
        <feather-icon icon="ChevronRightIcon"
      /></b-link>
    </b-media>
    <b-row class="px-2">
      <b-col class="d-flex flex-column" lg="6">
        <b-form-group
          class="w-100"
          label="Max participant (count) :"
          label-for="max-participant"
        >
          <div class="d-flex flex-wrap justify-conetent-start">
            <div class="col-md-7 col-12 px-0 mb-md-0 mb-1 d-flex">
              <validation-provider
                #default="{ errors }"
                name="max-participant"
                vid="max-participant"
                class="w-100"
                :rules="
                  'required|min-value:1|' +
                  (userData.plan && userData.plan.completion_max_participant
                    ? `max-value:${Number(
                        userData.plan.completion_max_participant
                      )}`
                    : '')
                "
              >
                <b-form-input
                  id="max-participant"
                  v-model="max_participant_value"
                  type="number"
                  :min="
                    userData.plan && userData.plan.completion_max_participant
                      ? Number(userData.plan.completion_max_participant)
                      : 1
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-75 rounded-circle cursor-pointer mt-1"
                v-b-tooltip.hover="
                  'How many people will you allow to register in the competition?'
                "
              />
            </div>
          </div>
        </b-form-group>
        <b-form-group
          class="w-100"
          label="Starting balance ($) :"
          label-for="starting-balance"
        >
          <div class="d-flex flex-wrap justify-conetent-start">
            <div class="col-md-7 col-12 px-0 mb-md-0 mb-1 d-flex">
              <validation-provider
                #default="{ errors }"
                name="starting-balance"
                vid="starting-balance"
                class="w-100"
                rules="required"
              >
                <b-form-input
                  id="starting-balance"
                  v-model="starting_balance_value"
                  type="number"
                  min="1"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-75 rounded-circle cursor-pointer mt-1"
                v-b-tooltip.hover="
                  'Specify the amount of money your participants must have at the beginning of the competition'
                "
              />
            </div>
            <validation-provider
              #default="{ errors }"
              name="starting-balance-operator"
              vid="starting-balance-operator"
              :rules="String(starting_balance_value) ? 'required' : ''"
              class="col-md-4 col-12 px-md-50 px-0 mb-md-0 mb-1"
            >
              <select-box
                id="starting-balance-operator"
                v-model="starting_balance_operator"
                label="operator"
                select="value"
                :lists="operators"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>
        </b-form-group>
      </b-col>
      <b-col class="d-flex flex-column" lg="6">
        <b-form-group
          class="w-100"
          label="Sorting parametr :"
          label-for="sorting-parametr"
        >
          <div class="d-flex flex-wrap justify-conetent-start">
            <div class="col-md-7 col-12 px-0 mb-md-0 mb-1 d-flex">
              <validation-provider
                #default="{ errors }"
                name="sorting-parametr"
                vid="sorting-parametr"
                class="w-100"
                rules="required"
              >
                <select-box
                  id="sorting-parametr-operator"
                  v-model="sortingParametr"
                  select="value"
                  label="name"
                  :lists="sortingParametrs"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-75 rounded-circle cursor-pointer mt-1"
                v-b-tooltip.hover="
                  sortingParametr == 'minimum_trade'
                    ? 'If the number of participants’ trades is less than the minimum number indicated here, their results will not be accepted'
                    : sortingParametr == 'profit'
                    ? ''
                    : 'This is one of the criteria for selecting your winners. Choose carefully!'
                "
              />
            </div>
            <validation-provider
              #default="{ errors }"
              :name="`${sortingParametr}-operator`"
              :vid="`${sortingParametr}-operator`"
              class="col-md-4 col-12 px-md-50 px-0 mb-md-0 mb-1"
              :rules="String(draw_down_value) ? 'required' : ''"
              v-if="sortingParametr == 'draw_down'"
            >
              <select-box
                :id="`${sortingParametr}-operator`"
                v-model="draw_down_operator"
                label="operator"
                select="value"
                :lists="[
                  { operator: 'Descending', value: 'GT' },
                  { operator: 'Ascending', value: 'LT' },
                ]"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <validation-provider
              v-if="sortingParametr == 'profit'"
              #default="{ errors }"
              :name="`${sortingParametr}-operator`"
              :vid="`${sortingParametr}-operator`"
              class="col-md-4 col-12 px-md-50 px-0 mb-md-0 mb-1"
              :rules="String(profit_value) ? 'required' : ''"
            >
              <select-box
                :id="`${sortingParametr}-operator`"
                v-model="profit_operator"
                label="operator"
                select="value"
                :lists="[
                  { operator: 'Descending', value: 'GT' },
                  { operator: 'Ascending', value: 'LT' },
                ]"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <validation-provider
              v-if="sortingParametr == 'minimum_trade'"
              #default="{ errors }"
              :name="`${sortingParametr}-operator`"
              :vid="`${sortingParametr}-operator`"
              class="col-md-4 col-12 px-md-50 px-0 mb-md-0 mb-1"
              :rules="String(minimum_trade_value) ? 'required' : ''"
            >
              <select-box
                :id="`${sortingParametr}-operator`"
                v-model="minimum_trade_operator"
                label="operator"
                select="value"
                :lists="[
                  { operator: 'Descending', value: 'GT' },
                  { operator: 'Ascending', value: 'LT' },
                ]"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>
        </b-form-group>
        <div class="w-100">
          <hr />
        </div>
        <div class="d-flex justify-content-between">
          <small class="mb-1">Kicking parametr :</small>
          <b-button
            @click="addOtherSortingParametrs"
            size="sm"
            v-if="otherSortingParametrs.length < 2"
            >Add other sorting parametrs</b-button
          >
        </div>
        <b-form-group
          class="w-100"
          label-class="mb-1"
          label-for="kicking-parametr"
          v-if="sortingParametr && otherSortingParametrs.length"
        >
          <b-form-group
            v-for="(item, index) in otherSortingParametrs"
            :key="index"
            class="w-100"
            :label="`${item.name} :`"
            :label-for="item.value"
          >
            <div
              class="d-flex flex-wrap justify-conetent-start "
            >
              <div class="col-md-7 col-12 px-0 mb-md-0 mb-1 d-flex">
                <validation-provider
                  #default="{ errors }"
                  :name="item.value"
                  :vid="item.value"
                  class="w-100"
                  rules="required"
                >
                  <b-form-input
                    v-if="item.value == 'minimum_trade'"
                    :id="item.value"
                    v-model="minimum_trade_value"
                    type="number"
                    min="1"
                  />
                  <b-form-input
                    v-if="item.value == 'profit'"
                    :id="item.value"
                    v-model="profit_value"
                    type="number"
                    min="1"
                  />
                  <b-form-input
                    v-if="item.value == 'draw_down'"
                    :id="item.value"
                    v-model="draw_down_value"
                    type="number"
                    min="1"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <feather-icon
                  icon="HelpCircleIcon"
                  size="22"
                  class="font-weight-bolder ml-75 rounded-circle cursor-pointer mt-1"
                  v-b-tooltip.hover="
                    item.value == 'minimum_trade'
                      ? 'If the number of participants’ trades is less than the minimum number indicated here, their results will not be accepted'
                      : item.value == 'profit'
                      ? ''
                      : 'This is one of the criteria for selecting your winners. Choose carefully!'
                  "
                />
              </div>
              <validation-provider
                #default="{ errors }"
                :name="`${item.value}-operator`"
                :vid="`${item.value}-operator`"
                class="col-md-4 col-12 px-md-50 px-0 mb-md-0 mb-1"
                :rules="String(draw_down_value) ? 'required' : ''"
                v-if="item.value == 'draw_down'"
              >
                <select-box
                  :id="`${item.value}-operator`"
                  v-model="draw_down_operator"
                  label="operator"
                  select="value"
                  :lists="operators"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <validation-provider
                v-if="item.value == 'profit'"
                #default="{ errors }"
                :name="`${item.value}-operator`"
                :vid="`${item.value}-operator`"
                class="col-md-4 col-12 px-md-50 px-0 mb-md-0 mb-1"
                :rules="String(profit_value) ? 'required' : ''"
              >
                <select-box
                  :id="`${item.value}-operator`"
                  v-model="profit_operator"
                  label="operator"
                  select="value"
                  :lists="operators"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <validation-provider
                v-if="item.value == 'minimum_trade'"
                #default="{ errors }"
                :name="`${item.value}-operator`"
                :vid="`${item.value}-operator`"
                class="col-md-4 col-12 px-md-50 px-0 mb-md-0 mb-1"
                :rules="String(minimum_trade_value) ? 'required' : ''"
              >
                <select-box
                  :id="`${item.value}-operator`"
                  v-model="minimum_trade_operator"
                  label="operator"
                  select="value"
                  :lists="operators"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <feather-icon
                icon="XIcon"
                size="22"
                class="font-weight-bolder ml-75 rounded-circle cursor-pointer mt-1"
                @click="removeSortingParametr(item, index)"
              />
            </div>
          </b-form-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BBadge,
  BButton,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BCardBody,
  BImg,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  VBTooltip,
  BLink,
} from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import { required } from "@validations";
import SelectBox from "@core/components/select-box/SelectBox.vue";

export default {
  components: {
    BRow,
    BCol,
    BBadge,
    BButton,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BCardBody,
    BImg,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    flatPickr,
    SelectBox,
    BLink,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      max_participant_value: "",
      max_participant_operator: "EQ",
      starting_balance_value: "",
      starting_balance_operator: "",
      draw_down_value: "",
      draw_down_operator: "",
      draw_down_weight: "",
      minimum_trade_value: 0,
      minimum_trade_operator: "",
      minimum_trade_weight: "",
      profit_value: "",
      profit_operator: "",
      profit_weight: "",
      sortingParametr: "minimum_trade",
      sortingParametrs: [
        { name: "Profit ($)", value: "profit" },
        { name: "Trade (count)", value: "minimum_trade" },
        { name: "Draw down (%)", value: "draw_down" },
      ],
      otherSortingParametrs: [
        { name: "Profit ($)", value: "profit" },
        { name: "Draw down (%)", value: "draw_down" },
      ],
      operators: [
        { operator: "Greater than", value: "GT" },
        { operator: "Greater than / Equal to", value: "GTE" },
        { operator: "Equal to", value: "EQ" },
        { operator: "Lower than / Equal to", value: "LTE" },
        { operator: "Lower than", value: "LT" },
      ],
      required,
    };
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
    list() {
      return {
        max_participant_value: this.max_participant_value,
        max_participant_operator: this.max_participant_operator,
        starting_balance_value: this.starting_balance_value,
        starting_balance_operator: this.starting_balance_operator,
        draw_down_value: this.draw_down_value,
        draw_down_operator: this.draw_down_operator,
        draw_down_weight: this.draw_down_weight,
        minimum_trade_value: this.minimum_trade_value,
        minimum_trade_operator: this.minimum_trade_operator,
        minimum_trade_weight: this.minimum_trade_weight,
        profit_value: this.profit_value,
        profit_operator: this.profit_operator,
        profit_weight: this.profit_weight,
      };
    },
  },
  watch: {
    sortingParametr(val) {
      if (val) {
        this[`${val}_value`] = 0;
        this[`${val}_weight`] = 3;
        this.otherSortingParametrs = this.sortingParametrs.filter((sort) => {
          return sort.value != val && this[`${sort.value}_value`];
        });
        this.otherSortingParametrs.forEach((item) => {
          this[`${item.value}_value`] = this[`${item.value}_value`]
            ? this[`${item.value}_value`]
            : "";
          this[`${item.value}_weight`] = 1;
        });
      } else {
        this.draw_down_value = "";
        this.draw_down_operator = "";
        this.draw_down_weight = "";
        this.minimum_trade_value = "";
        this.minimum_trade_operator = "";
        this.minimum_trade_weight = "";
        this.profit_value = "";
        this.profit_operator = "";
        this.profit_weigh = "";
      }
    },
    competition(val) {
      Object.keys(val).map((key) => {
        this[key] = val[key];
      });
      this.profit_weight == 3
        ? (this.sortingParametr = "profit")
        : this.minimum_trade_weight == 3
        ? (this.sortingParametr = "minimum_trade")
        : (this.sortingParametr = "draw_down");
    },
    list: {
      async handler(val) {
        this.$emit("rulesAndConditions", val);
      },
      deep: true,
    },
  },

  methods: {
    addOtherSortingParametrs() {
      this.otherSortingParametrs = this.sortingParametrs.filter(
        (sort) => sort.value != this.sortingParametr
      );
      this.otherSortingParametrs.forEach((item) => {
        this[`${item.value}_value`] = this[`${item.value}_value`]
          ? this[`${item.value}_value`]
          : "";
        this[`${item.value}_weight`] = 1;
      });
    },
    removeSortingParametr(item, index) {
      this[`${item.value}_value`] = 0;
      this[`${item.value}_weight`] = 0;
      this.otherSortingParametrs.splice(index, 1);
    },
  },
};
</script>
